//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import utils from "@/util/utils";
import { getLeaveMsgRepeat, getLeaveMsgDetail } from "@/api/personalCenter/suggestAngMsg";
export default {
  name: "answerMsgDialog",
  components: {},
  props: [],
  data: function data() {
    return {
      contentTime: "",
      show: false,
      loading: false,
      msgList: [],
      form: {
        answerBy: "",
        answerTime: "",
        content: "",
        _content: "",
        msgId: "",
        serveId: ""
      },
      param: {}
    };
  },
  computed: {},
  methods: {
    // 显示弹框
    dialogShow: function dialogShow(data) {
      this.show = true;
      this.form._content = data.msgContent;
      this.form.answer = data.answerContent;
      this.contentTime = data.createTime;
      this.form.msgId = data.msgId;
      this.form.serveId = data.serveId;
      this.form.answerBy = this.$store.getters.userData.userName;
    },
    // getLeaveMsgDetail(){
    //     this.loading = true;
    //     getLeaveMsgDetail(this.param).then(({data})=>{
    //         this.loading = false;
    //         if(data.code == 0){
    //             this.msgList=(data.data||[]).reverse();
    //             this.$nextTick(() => {
    //                 let container = this.$el.querySelector(".msg-detail");
    //                 container.scrollTop = container.scrollHeight;
    //             });
    //         }else{
    //             this.$message.warning( "获取留言信息失败！" );
    //         }
    //     }).catch(err=>{
    //         this.loading = false;
    //     })
    //
    //
    // },
    getLeaveMsgRepeatFn: function getLeaveMsgRepeatFn() {
      var _this = this;

      this.loading = true;
      getLeaveMsgRepeat(this.form).then(function (_ref) {
        var data = _ref.data;
        _this.loading = false;

        if (data.code == 0) {
          _this.show = false;

          _this.$message.success("留言成功!");

          _this.$emit("saveSuccess");

          _this.form.content = "";
        } else {
          _this.$message.warning(data.msg || "留言失败!");
        }
      }).catch(function (err) {
        _this.loading = false;

        _this.$message.error("服务器异常!");
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      if (!this.form.content) {
        this.$message.warning("请输入要留言的内容!");
        return;
      }

      this.getLeaveMsgRepeatFn();
    }
  },
  watch: {
    show: function show(val) {
      if (!val) {
        this.form.content = "";
      }
    }
  },
  filters: {}
};